<!--P030、P015、P017、P018、P029-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'ShopManage'})">门店维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">门店详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">门店编号</div>
      <div class="cs_radius_lg txt_info_search">{{search.shopNum}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">门店名称</div>
      <input v-model="search.shopName" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">品牌</div>
      <web-select :options="search.brandList"
                  @option-key="updateBrand"
                  v-model="search.brandName"
                  class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_44"></web-select>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">负责人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search ui_margin_left_30" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">所在地址</div>
      <input v-model="search.shopAddress" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_440" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{DISTRIBUTION_CENTER_STATUS[search.isStop]}}</div>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue cs_margin_top_sm" style="margin-left: 182px;"
              type="button">保存
      </button>
    </div>

    <!--接入管理-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">接入管理</div>
    </div>
    <div class="cs_margin_top ui_switch">
      <button @click="showSupplier" :class="[linkManage==='SUPPLIER'?'ui_switch_selected':'']"
              type="button">供应商接入
      </button>
      <button @click="showDc" :class="[linkManage==='DISTRIBUTIONCENTER'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">配送中心接入
      </button>
    </div>
    <div class="div_search_result cs_padding_top_lg">
      <!--供应商表格-->
      <template v-if="linkManage==='SUPPLIER'">
        <div class="div_operation_table">
          <button @click="btnAddSupplier" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteSupplier" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="320px">供应商编号</th>
              <th width="480px">供应商名称</th>
              <th width="241px">供应商启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in supplierList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrSupplier(item)">
              <td>{{index+1}}</td>
              <td>{{item.supplierNum}}</td>
              <td>{{item.supplierName}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-supplierList.length)">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--配送中心表格-->
      <template v-if="linkManage==='DISTRIBUTIONCENTER'">
        <div class="div_operation_table cs_align_center" style="height: 250px;">
          <div class="cs_title_primary cs_text_default type_info_search">接入配送中心</div>
          <div class="cs_input cs_radius_lg txt_info_search">{{dcName}}</div>
        </div>
      </template>
      <!--供应商分页-->
      <div v-show="linkManage==='SUPPLIER'" class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="pageLink(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="pageLink(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jumpLink()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>

    <!--货品管理-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">货品管理</div>
    </div>
    <div class="cs_margin_top ui_switch">
      <button @click="showPurchase" :class="[materialManage==='PURCHASE'?'ui_switch_selected':'']"
              type="button">采购货品管理
      </button>
      <button @click="showRequire" :class="[materialManage==='REQUIRE'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">要货货品管理
      </button>
    </div>
    <!--采购查询-->
    <div v-if="materialManage==='PURCHASE'" class="div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">默认供应商</div>
      <search-select :options="searchPurchase.supplierSearchItems"
                     @option-key="updateSupplierNamePurchase"
                     v-model="searchPurchase.supplierName"
                     :search-fn="acquireSupplierItemPurchase"
                     class="cs_input cs_radius_lg edtxt_info_search width_280"></search-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品</div>
      <input v-model="searchPurchase.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="acquirePurchase(1)">查询</button>
    </div>
    <!--要货查询-->
    <div v-if="materialManage==='REQUIRE'" class="div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">货品</div>
      <input v-model="searchRequire.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="acquireRequire(1)">查询</button>
    </div>
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <!--采购表格-->
      <template v-if="materialManage==='PURCHASE'">
        <div class="div_operation_table">
          <button @click="btnAddPurchase" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnModifyPurchase" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">修改
          </button>
          <button @click="btnDeletePurchase" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="120px">货品编号</th>
              <th width="250px">货品名称</th>
              <th width="100px">规格</th>
              <th width="96px">采购单位</th>
              <th width="210px">默认供应商</th>
              <th width="132px">采购单价</th>
              <th width="130px">货品启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in purchaseList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrPurchase(item)">
              <td>{{index+1}}</td>
              <td>{{item.materialNum}}</td>
              <td>{{item.materialName}}</td>
              <td>{{item.materialSpecs}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.sourceName}}</td>
              <td>{{item.unitPrice}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-purchaseList.length)">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>
          <div class="div_bottom_information">
            <div class="div_amount_information">
              货品数量： {{searchMaterial.totalItem}}
            </div>
            <button @click="exportPurchaseBtn" class="div_btn_export" style="width:128px;"
                    type="button">采购列表导出
            </button>
            <!--货品分页-->
            <div class="div_page">
              <!--上一页-->
              <button v-show="searchMaterial.pagination>1" @click="pageMaterial(searchMaterial.pagination < 2?1:searchMaterial.pagination-1)"
                      class="btn_page_up" type="button">
              </button>
              <button v-show="searchMaterial.pagination<=1" class="btn_page_up_disable" type="button"></button>
              <div class="current_page">{{searchMaterial.pagination}}</div>
              <div class="oblique_line">/</div>
              <div class="total_page">{{searchMaterial.totalPage}}</div>
              <!--下一页-->
              <button v-show="searchMaterial.pagination!==searchMaterial.totalPage" @click="pageMaterial(searchMaterial.pagination+1)" class="btn_page_down" type="button"></button>
              <button v-show="searchMaterial.pagination===searchMaterial.totalPage" class="btn_page_down_disable" type="button"></button>
              <div @click="jumpMaterial()" class="type_page_jump">跳转至</div>
              <input v-model="searchMaterial.pageJump" class="txt_page_jump" type="text"
                     @keyup="checkPositiveInt($event)" @blur="searchMaterial.pageJump=checkPositiveInt($event)">
            </div>
          </div>
        </div>
      </template>
      <!--要货表格-->
      <template v-if="materialManage==='REQUIRE'">
        <div class="div_operation_table">
          <button @click="btnAddRequire" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteRequire" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="120px">货品编号</th>
              <th width="327px">货品名称</th>
              <th width="100px">规格</th>
              <th width="190px">要货单位</th>
              <th width="142px">配送单价</th>
              <th width="160px">货品启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in requireList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrRequire(item)">
              <td>{{index+1}}</td>
              <td>{{item.materialNum}}</td>
              <td>{{item.materialName}}</td>
              <td>{{item.materialSpecs}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.unitPrice}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-requireList.length)">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>
          <div class="div_bottom_information">
            <div class="div_amount_information">
              货品数量：{{searchMaterial.totalItem}}
            </div>
            <button @click="exportRequireBtn" class="div_btn_export" style="width:128px;"
                    type="button">配送列表导出
            </button>
            <!--货品分页-->
            <div class="div_page">
              <!--上一页-->
              <button v-show="searchMaterial.pagination>1" @click="pageMaterial(searchMaterial.pagination < 2?1:searchMaterial.pagination-1)"
                      class="btn_page_up" type="button">
              </button>
              <button v-show="searchMaterial.pagination<=1" class="btn_page_up_disable" type="button"></button>
              <div class="current_page">{{searchMaterial.pagination}}</div>
              <div class="oblique_line">/</div>
              <div class="total_page">{{searchMaterial.totalPage}}</div>
              <!--下一页-->
              <button v-show="searchMaterial.pagination!==searchMaterial.totalPage" @click="pageMaterial(searchMaterial.pagination+1)" class="btn_page_down" type="button"></button>
              <button v-show="searchMaterial.pagination===searchMaterial.totalPage" class="btn_page_down_disable" type="button"></button>
              <div @click="jumpMaterial()" class="type_page_jump">跳转至</div>
              <input v-model="searchMaterial.pageJump" class="txt_page_jump" type="text"
                     @keyup="checkPositiveInt($event)" @blur="searchMaterial.pageJump=checkPositiveInt($event)">
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="div_bottom"></div>

    <!--接入供应商弹窗，默认隐藏-->
    <div v-if="isDialogSupplierShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:386px;height:266px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">接入供应商</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">供应商</div>
          <search-select :options="dialogSupplier.supplierSearchItems"
                         @option-key="updateSupplierName"
                         v-model="dialogSupplier.supplierName"
                         :search-fn="acquireSupplierItem"
                         class="cs_input cs_radius_lg edtxt_info_search width_246"></search-select>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{dialogSupplier.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogLink">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialogSupplier">确定</button>
        </div>
      </div>
    </div>
    <!--添加采购弹窗，默认隐藏-->
    <div v-if="isDialogPurchaseShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:466px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加采购货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogPurchase.materialSearchItems"
                         @option-key="updateMaterialNamePurchase"
                         v-model="dialogPurchase.materialName"
                         :search-fn="acquireMaterialItemPurchase"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogPurchase.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单位</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogPurchase.purchaseUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">默认供应商</div>
          <web-select :options="dialogPurchase.supplierList"
                      @option-key="updateSupplierPurchase"
                      v-model="dialogPurchase.supplierName"
                      class="cs_input cs_radius_lg edtxt_info_search width_246"></web-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单价</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogPurchase.unitPrice}}</div>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogPurchase.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmPurchaseDialog">确定</button>
        </div>
      </div>
    </div>
    <!--修改采购弹窗，默认隐藏-->
    <div v-if="isDialogModifyPurchaseShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:466px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">修改采购货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogModifyPurchase.materialName}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogModifyPurchase.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单位</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogModifyPurchase.purchaseUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">默认供应商</div>
          <web-select :options="dialogModifyPurchase.supplierList"
                      @option-key="updateSupplierPurchaseModify"
                      v-model="dialogModifyPurchase.supplierName"
                      class="cs_input cs_radius_lg edtxt_info_search width_246"></web-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单价</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogModifyPurchase.unitPrice}}</div>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogModifyPurchase.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmPurchaseDialogModify">确定</button>
        </div>
      </div>
    </div>
    <!--添加要货货品弹窗，默认隐藏-->
    <div v-if="isDialogRequireShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:416px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加要货货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogRequire.materialSearchItems"
                         @option-key="updateMaterialNameRequire"
                         v-model="dialogRequire.materialName"
                         :search-fn="acquireMaterialItemRequire"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_44">{{dialogRequire.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">要货单位</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogRequire.stockUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">配送单价</div>
          <input v-model="priceRequire" class="cs_input cs_radius_lg edtxt_info_search width_246" @keyup="inputLimitPositiveFloat($event)" @blur="priceRequire=formatPositiveFloat($event)">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogRequire.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmRequireDialog">确定</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  import {Page, PAGE_SIZE,DISTRIBUTION_CENTER_STATUS,SHOP_STATUS} from "../../assets/utils/constants"
  export default {
    name: "ShopDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        linkManage: "SUPPLIER",
        search: {
          shopNum: "",
          shopName: "",
          contactName: "",
          mobileNo: "",
          shopAddress: "",
          isStop: "",
          brandList:[],
          brandId:"",
          brandName:"",
          pageJump: "",
          totalPage: "",
          pagination: 1
        },
        supplierList: [],
        selectedIdSupplier: "",
        isDialogSupplierShow: false,
        dialogSupplier: {
          supplierId: "",
          supplierName: "",
          supplierSearchItems: [],
          hintDialog: "",
        },
        dcId: "",
        dcName: "",
        materialManage: "PURCHASE",
        searchMaterial: {
          totalItem: "",
          pageJump: "",
          totalPage: "",
          pagination: 1
        },
        searchPurchase: {
          name: "",
          supplierId: 0,
          supplierName: "",
          supplierSearchItems: [],
        },
        purchaseList: [],
        selectedIdPurchase: "",
        isDialogPurchaseShow: false,
        dialogPurchase: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          purchaseUnit: "",
          supplierId: "",
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        },
        isDialogModifyPurchaseShow: false,
        dialogModifyPurchase: {
          materialId: "",
          materialName: "",
          purchaseUnit: "",
          supplierId: "",
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        },
        searchRequire: {
          name: "",
        },
        requireList: [],
        selectedIdRequire: "",
        isDialogRequireShow: false,
        dialogRequire: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          stockUnit: "",
          materialSpecs:""
        },
        priceRequire: "",

        PAGE_SIZE: PAGE_SIZE,
        DISTRIBUTION_CENTER_STATUS: DISTRIBUTION_CENTER_STATUS,
        SHOP_STATUS: SHOP_STATUS
      }
    },
    created: function () {
      this.showDetail();
      if(this.linkManage === "SUPPLIER"){
        this.showSupplier();
      }else {
        this.showDc();
      }
      if(this.materialManage === "PURCHASE"){
        this.showPurchase();
      }else{
        this.showRequire();
      }
      this.showBrand();
    },
    mounted: function() {
    },
    methods: {
      showBrand(){
        this.$ajax.brand.list.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].brandName,
            })
          }
          this.search.brandList = array;
        }, (data) => {
        }, true)
      },
      updateBrand(key) {
        this.search.brandId = key;
      },
      showDetail(){
        this.$ajax.shop.acquireShopDetail.bind(this)(this.$route.query.id,(data) => {
          this.search.shopNum = data.data.shopNum;
          this.search.shopName = data.data.shopName;
          this.search.contactName = data.data.contactName;
          this.search.mobileNo = data.data.mobileNo;
          this.search.shopAddress = data.data.shopAddress;
          this.search.isStop = data.data.stop;
          this.dcId = data.data.dcId;
          this.dcName = data.data.dcName;
          this.search.brandId = data.data.brandId;
          this.search.brandName = data.data.brandName;
        }, (data) => {
        }, true)
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.shopName, "门店名称");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.brandId)){
          this.$toast("请选择品牌");
          return;
        }
        this.$ajax.shop.modifyShop.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
        }, (data) => {
        }, true)
      },
      // 供应商
      showSupplier() {
        this.linkManage = "SUPPLIER";
        this.search.pageJump = "";
        this.acquireSupplier(1);
      },
      showDc() {
        this.linkManage = "DISTRIBUTIONCENTER";
      },
      pageLink(pagination){
        this.acquireSupplier(pagination);
      },
      jumpLink() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.acquireSupplier(this.search.totalPage);
          }else {
            this.acquireSupplier(this.search.pageJump);
          }
        }
      },
      acquireSupplier(pagination){
        this.$ajax.shop.listSupplier.bind(this)(this.$route.query.id, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.supplierList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrSupplier(item){
        let selectedStatus = item.isSelected;
        this.supplierList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdSupplier = item.id;
        }else {
          this.selectedIdSupplier = "";
        }
      },
      btnDeleteSupplier(){
        if(this.isEmpty(this.selectedIdSupplier)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.shop.deleteSupplier.bind(this)(this.$route.query.id,this.selectedIdSupplier, (data) => {
          this.$toast("删除成功");
          this.selectedIdSupplier = "";
          this.acquireSupplier(this.search.pagination);
        }, (data) => {
        }, true)
      },
      btnAddSupplier(){
        this.isDialogSupplierShow = true;
      },
      btnConfirmDialogSupplier(){
        if (this.isEmpty(this.dialogSupplier.supplierId)) {
          this.dialogSupplier.hintDialog= "请选择供应商";
          return
        }
        this.$ajax.shop.addSupplier.bind(this)(this.$route.query.id,this.dialogSupplier.supplierId, (data) => {
          this.$toast("添加成功");
          this.acquireSupplier(this.search.pagination);
          this.closeDialogLink();
        }, (data) => {
        }, true,this.showErrorMsgSupplier())
      },
      acquireSupplierItem(search) {
        this.$ajax.common.searchSupplier.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum + "  " + data.data[i].supplierName,
            })
          }
          this.dialogSupplier.supplierSearchItems = array;
        }, this.failDefault, false);
      },
      updateSupplierName(key) {
        this.dialogSupplier.supplierId = key;
      },
      showErrorMsgSupplier: function (msg) {
        this.dialogSupplier.hintDialog = msg;
      },
      closeDialogLink(){
        this.isDialogSupplierShow = false;
        this.dialogSupplier = {
          supplierId: "",
          supplierName: "",
          supplierSearchItems: [],
          hintDialog: "",
        };
      },

      // 采购
      showPurchase(){
        this.materialManage = "PURCHASE";
        this.searchMaterial.pageJump = "";
        this.acquirePurchase(1);
      },
      acquirePurchase(pagination){
        this.$ajax.shop.listPurchaseMaterial.bind(this)(this.$route.query.id,this.searchPurchase.supplierId, this.searchPurchase.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.searchMaterial.totalPage = data.data.totalPage;
          this.searchMaterial.pagination = data.data.pagination;
          this.searchMaterial.totalItem = data.data.totalItem;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.purchaseList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrPurchase(item){
        let selectedStatus = item.isSelected;
        this.purchaseList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdPurchase = item.materialId;
        }else {
          this.selectedIdPurchase = "";
        }
      },
      btnDeletePurchase(){
        if(this.isEmpty(this.selectedIdPurchase)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.shop.deleteMaterial.bind(this)(this.$route.query.id,this.selectedIdPurchase, (data) => {
          this.$toast("删除成功");
          this.selectedIdPurchase = "";
          this.acquirePurchase(this.searchMaterial.pagination);
        }, (data) => {
        }, true)
      },
      btnAddPurchase(){
        this.isDialogPurchaseShow = true;
      },
      btnConfirmPurchaseDialog(){
        if (this.isEmpty(this.dialogPurchase.materialId)) {
          this.dialogPurchase.hintDialog = "请选择货品";
          return
        }
        if (this.isEmptySelect(this.dialogPurchase.supplierId)) {
          this.dialogPurchase.hintDialog = "请选择默认供应商";
          return
        }
        this.$ajax.shop.addPurchaseMaterial.bind(this)(this.$route.query.id,this.dialogPurchase.materialId,this.dialogPurchase.supplierId, (data) => {
          this.$toast("添加成功");
          this.acquirePurchase(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgPurchase)
      },
      acquireMaterialItemPurchase(search) {
        this.$ajax.common.searchMaterial.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              purchaseUnit: data.data[i].purchaseUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogPurchase.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNamePurchase(key) {
        this.dialogPurchase.materialId = key;
        if(!this.isEmpty(key)){
          this.acquireSupplierListPurchase(key);
          for(let i=0;i<this.dialogPurchase.materialSearchItems.length;i++){
            if(this.dialogPurchase.materialSearchItems[i].key === key){
              this.dialogPurchase.purchaseUnit = this.dialogPurchase.materialSearchItems[i].purchaseUnit;
              this.dialogPurchase.materialSpecs = this.dialogPurchase.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogPurchase.hintDialog = "";
          this.dialogPurchase.purchaseUnit = "";
          this.dialogPurchase.materialSpecs = "";
          this.dialogPurchase.supplierList = [];
          this.dialogPurchase.supplierId = "";
          this.dialogPurchase.supplierName = "";
          this.dialogPurchase.unitPrice = "";
        }
      },
      showErrorMsgPurchase: function (msg) {
        this.dialogPurchase.hintDialog = msg;
      },
      acquireSupplierItemPurchase(search) {
        this.$ajax.common.searchSupplier.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum + "  " + data.data[i].supplierName,
            })
          }
          this.searchPurchase.supplierSearchItems = array;
        }, this.failDefault, false);
      },
      updateSupplierNamePurchase(key) {
        if(!this.isEmpty(key)){
          this.searchPurchase.supplierId = key;
          return;
        }
        this.searchPurchase.supplierId = 0;
      },
      acquireSupplierListPurchase(materialId){
        this.$ajax.common.listSupplierByMaterial.bind(this)(materialId,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum +"  "+ data.data[i].supplierName,
              unitPrice: data.data[i].unitPrice,
            })
          }
          this.dialogPurchase.supplierList = array;
        }, (data) => {
        }, true)
      },
      updateSupplierPurchase(key) {
        this.dialogPurchase.supplierId = key;
        if(!this.isEmptySelect(key)){
          for(let i=0;i<this.dialogPurchase.supplierList.length;i++){
            if(this.dialogPurchase.supplierList[i].key === key){
              this.dialogPurchase.unitPrice = this.dialogPurchase.supplierList[i].unitPrice;
              return;
            }
          }
        }else {
          this.dialogPurchase.hintDialog = "";
          this.dialogPurchase.unitPrice = "";
        }
      },
      btnModifyPurchase(){
        if(this.isEmpty(this.selectedIdPurchase)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.purchaseList.some((item) => {
          if(this.selectedIdPurchase === item.materialId){
            this.dialogModifyPurchase.materialId = item.materialId;
            this.dialogModifyPurchase.materialName= item.materialNum+ "  "+item.materialName;
            this.dialogModifyPurchase.purchaseUnit= item.unit;
            this.dialogModifyPurchase.supplierId= item.sourceId;
            this.dialogModifyPurchase.supplierName= item.sourceNum+"  "+item.sourceName;
            this.dialogModifyPurchase.unitPrice= item.unitPrice;
            this.dialogModifyPurchase.materialSpecs= item.materialSpecs;
            return true;
          }
        });
        this.acquireSupplierListPurchaseModify(this.selectedIdPurchase);
        this.isDialogModifyPurchaseShow = true;
      },
      btnConfirmPurchaseDialogModify(){
        if (this.isEmpty(this.dialogModifyPurchase.supplierId)) {
          this.dialogModifyPurchase.hintDialog = "请选择默认供应商";
          return
        }
        this.$ajax.shop.modifyPurchaseMaterial.bind(this)(this.$route.query.id,this.dialogModifyPurchase.materialId,this.dialogModifyPurchase.supplierId, (data) => {
          this.$toast("修改成功");
          this.acquirePurchase(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgPurchaseModify)
      },
      showErrorMsgPurchaseModify: function (msg) {
        this.dialogModifyPurchase.hintDialog = msg;
      },
      acquireSupplierListPurchaseModify(materialId){
        this.$ajax.common.listSupplierByMaterial.bind(this)(materialId,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum +"  "+ data.data[i].supplierName,
              unitPrice: data.data[i].unitPrice,
            })
          }
          this.dialogModifyPurchase.supplierList = array;
        }, (data) => {
        }, true)
      },
      updateSupplierPurchaseModify(key) {
        this.dialogModifyPurchase.supplierId = key;
        if(!this.isEmptySelect(key)){
          for(let i=0;i<this.dialogModifyPurchase.supplierList.length;i++){
            if(this.dialogModifyPurchase.supplierList[i].key === key){
              this.dialogModifyPurchase.unitPrice = this.dialogModifyPurchase.supplierList[i].unitPrice;
              return;
            }
          }
        }else {
          this.dialogModifyPurchase.hintDialog = "";
          this.dialogModifyPurchase.unitPrice = "";
        }
      },
      pageMaterial(pagination){
        if(this.materialManage === "PURCHASE"){
          this.acquirePurchase(pagination);
        }else {
          this.acquireRequire(pagination);
        }
      },
      jumpMaterial() {
        if (!this.isEmpty(this.searchMaterial.pageJump)) {
          let searchPage = this.searchMaterial.pageJump>this.searchMaterial.totalPage?this.searchMaterial.totalPage:this.searchMaterial.pageJump;
          if(this.materialManage === "PURCHASE"){
            this.acquirePurchase(searchPage);
          }else {
            this.acquireRequire(searchPage);
          }
        }
      },
      closeDialogMaterial(){
        this.isDialogPurchaseShow = false;
        this.dialogPurchase = {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          purchaseUnit: "",
          supplierId: "",
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        };
        this.isDialogModifyPurchaseShow= false;
        this.dialogModifyPurchase= {
          materialId: "",
          materialName: "",
          purchaseUnit: "",
          supplierId: "",
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        };
        this.isDialogRequireShow= false;
        this.dialogRequire= {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          stockUnit: "",
          materialSpecs:""
        };
        this.priceRequire= "";
      },

      // 要货
      showRequire(){
        this.materialManage = "REQUIRE";
        this.searchMaterial.pageJump = "";
        this.acquireRequire(1);
      },
      acquireRequire(pagination){
        this.$ajax.shop.listRequireMaterial.bind(this)(this.$route.query.id,this.searchRequire.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.searchMaterial.totalPage = data.data.totalPage;
          this.searchMaterial.pagination = data.data.pagination;
          this.searchMaterial.totalItem = data.data.totalItem;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.requireList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrRequire(item){
        let selectedStatus = item.isSelected;
        this.requireList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdRequire = item.materialId;
        }else {
          this.selectedIdRequire = "";
        }
      },
      btnDeleteRequire(){
        if(this.isEmpty(this.selectedIdRequire)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.shop.deleteMaterial.bind(this)(this.$route.query.id,this.selectedIdRequire, (data) => {
          this.$toast("删除成功");
          this.selectedIdRequire = "";
          this.acquireRequire(this.searchMaterial.pagination);
        }, (data) => {
        }, true)
      },
      btnAddRequire(){
        if(this.isEmpty(this.dcId)){
          this.$toast("配送中心未接入");
          return;
        }
        this.isDialogRequireShow = true;
      },
      btnConfirmRequireDialog(){
        if (this.isEmpty(this.dialogRequire.materialId)) {
          this.dialogRequire.hintDialog = "请选中一个货品";
          return
        }
        if (this.isEmpty(this.priceRequire)) {
          this.dialogRequire.hintDialog = "请输入配送单价";
          return
        }
        this.$ajax.shop.addRequireMaterial.bind(this)(this.$route.query.id,this.dialogRequire.materialId,this.priceRequire, (data) => {
          this.$toast("添加成功");
          this.acquireRequire(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgRequire)
      },
      acquireMaterialItemRequire(search) {
        this.$ajax.distributionCenter.searchMaterial.bind(this)(this.dcId,search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].materialId,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              stockUnit: data.data[i].stockUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogRequire.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNameRequire(key) {
        this.dialogRequire.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogRequire.materialSearchItems.length;i++){
            if(this.dialogRequire.materialSearchItems[i].key === key){
              this.dialogRequire.stockUnit = this.dialogRequire.materialSearchItems[i].stockUnit;
              this.dialogRequire.materialSpecs = this.dialogRequire.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogRequire.hintDialog = "";
          this.dialogRequire.stockUnit = "";
          this.dialogRequire.materialName = "";
          this.dialogRequire.materialSpecs = "";
          this.priceRequire = "";
        }
      },
      showErrorMsgRequire: function (msg) {
        this.dialogRequire.hintDialog = msg;
      },

      failDefault() {
      },
      exportPurchaseBtn(){
        this.$ajax.shop.exportPurchaseMaterial.bind(this)(this.$route.query.id,this.searchPurchase.supplierId,this.searchPurchase.name, (response) => {
          let fileName = "采购货品-"+this.getNowDateNoDivider()+".xls";
          this.downloadFileStream(response.data, fileName);
        }, (data) => {
        }, true)
      },
      exportRequireBtn(){
        this.$ajax.shop.exportRequireMaterial.bind(this)(this.$route.query.id,this.searchPurchase.name, (response) => {
          let fileName = "要货货品-"+this.getNowDateNoDivider()+".xls";
          this.downloadFileStream(response.data, fileName);
        }, (data) => {
        }, true)
      }
    },

  }
</script>

<style scoped>
  .width_440{
    width: 440px;
  }
  .width_246{width: 246px;}
  .width_108{width: 108px;}
  .width_280{width: 280px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .margin_left_18{margin-left: 18px;}
  .margin_top_12{margin-top: 12px;}
  .table_confirm tbody{max-height: 410px;}
  .div_bottom_information{
    position: relative;
    margin-top: 0;
    width: 100%;
    height: 76px;
  }
  .div_amount_information{
    position: absolute;
    top: 12px;
    left: 0;
    width: 100px;
    text-align: left;
    font-size: 12px;
    color: #666666;
  }
  .div_btn_export{
    position: absolute;
    top: 44px;
    left: 0;
    height: 32px;
    padding-left: 16px;
    font-size: 12px;
    color: #999999;
    line-height: 32px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    text-align: left;
    background: #FFFFFF url("../../assets/image/icon_export.png") no-repeat right 8px center;
    background-size: 16px 16px;
  }
  .div_btn_export:hover{
    color:#333333;
    border: 1px solid #666666;
    background: #FFFFFF url("../../assets/image/icon_export_hover.png") no-repeat right 8px center;
    background-size: 16px 16px;
  }
  .div_btn_export:active{
    color:#333333;
    border: 1px solid #CCCCCC;
    background: #EEEEEE url("../../assets/image/icon_export_hover.png") no-repeat right 8px center;
    background-size: 16px 16px;
  }
  .div_page{
    position: absolute;
    top: 24px;
    right: 0;
    height: 32px;
    font-size: 0;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/shop/ShopDetail.vue